<onsip-header-main>
  <onsip-header-page-title>E911</onsip-header-page-title>
</onsip-header-main>

<main>
  <div class="mat-headline-4 e911-text e911-get-started">
    {{ "ONSIP_I18N.GET_STARTED_WITH_E911" | translate }}
  </div>
  <div class="mat-body-2 e911-text">
    {{
      "ONSIP_I18N.E911_IS_NOW_ENABLED_ON_YOUR_ACCOUNT_YOU_CAN_NOW_CREATE_AND_ASSIGN_AN_EMERGENCY_RESPONSE_LOCATIONADD_A_LOCATION_TO_GET_STARTED"
        | translate
    }}
  </div>

  <button
    mat-flat-button
    color="primary"
    class="e911-add-location"
    (click)="openAddLocationModal()"
  >
    {{ "ONSIP_I18N.ADD_LOCATION" | translate | sentenceCase }}
  </button>

  <div class="mat-body-2 e911-text">
    {{
      "ONSIP_I18N.REQUIRES_CC__PSTN_BALANCE_FREE_TO_ENABLE__USERBASED_COST_OF_180_PER_MONTH_FOR_EACH_USER_ADDED_TO_A_LOCATION"
        | translate
    }}
  </div>
</main>
